import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchList as fetchRoomList } from '@/api/PMS/baseInformation/house';
import { fetchListByType } from '@/api/PMS/dic/dic';
import { fetchList as fetchChargeList } from '@/api/PMS/chargeManagement/chargingParameterSetting/chargingStandardSetting/chargingStandardSetting';
export default {
  props: {
    isAddContract: Boolean,
    baseInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    contractClauseList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    contractStandardList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    parkingLotList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    state: {
      type: String,
      default: 'add'
    },
    isGeneratingBills: Boolean,
    showDialog: Boolean
  },
  data: function data() {
    return {
      rules: {
        upIdList: [{
          required: true,
          message: '请选择房间',
          trigger: 'change'
        }]
      },
      couldNext: true,
      clauseList: [{}],
      vehicleList: [],
      standardList: [],
      roomOption: [],
      bindList: [],
      houseOption: [],
      plateOption: [],
      modelOption: [],
      vehicleTypeOption: [],
      undertakerOption: [{
        value: 2,
        name: '租户'
      }, {
        value: 1,
        name: '业主'
      }],
      projectOption: [],
      chargeOption: []
    };
  },
  watch: {
    baseInfo: {
      handler: function handler(val, oldval) {
        this.loadRoomOption();
      },
      deep: true
    },
    parkingLotList: {
      handler: function handler(val, oldval) {
        var _this = this;

        setTimeout(function () {
          _this.handleParkLotOption(val);
        });
      },
      deep: true,
      immediate: true
    },
    contractClauseList: {
      handler: function handler(val, oldval) {
        this.clauseList = val;
      },
      deep: true,
      immediate: true
    },
    contractStandardList: {
      handler: function handler(val, oldval) {
        this.standardList = val;
      },
      deep: true,
      immediate: true
    },
    clauseList: {
      handler: function handler(val, oldval) {
        this.$emit('generatingBills', {
          clauseList: this.clauseList,
          standardList: this.standardList
        });
      },
      deep: true
    },
    standardList: {
      handler: function handler(val, oldval) {
        this.$emit('generatingBills', {
          clauseList: this.clauseList,
          standardList: this.standardList
        });
      },
      deep: true
    }
  },
  created: function created() {
    this.init();
    this.loadChargeOption();
    this.loadPlateOption();
    this.loadVehicleTypeOption();
    this.loadModelOption();
  },
  methods: {
    init: function init() {
      if (this.isAddContract) {
        this.clauseList = [{
          leaseContractCarVos: []
        }];
        this.standardList = [];
      }
    },
    handleChargeStandard: function handleChargeStandard(val, index) {
      var standItem = this.chargeOption.find(function (item) {
        return item.chargeStandardId === val;
      });

      if (standItem) {
        this.standardList[index].chargeMath = standItem.chargeMath;
        this.standardList[index].chargePrice = standItem.standardPrice;
        this.standardList[index].fixedAmount = standItem.fixedAmount;
      }
    },
    handleParkLotOption: function handleParkLotOption(list) {
      var _this2 = this;

      this.init();
      this.clauseList.forEach(function (item1, index) {
        // if (!this.isGeneratingBills) this.$set(this.clauseList[index], 'houseId', '')
        // if (this.isAddContract) { this.$set(this.clauseList[index], 'leaseContractCarVos', []) }
        var parkLotListOption = list.map(function (item2) {
          return {
            value: item2.resourceId,
            name: item2.resourceCode
          };
        });
        var leaseContractTeamsResourceVos = list.map(function (item2) {
          return item2.resourceId;
        });

        _this2.$set(_this2.clauseList[index], 'parkLotListOption', parkLotListOption);

        _this2.$set(_this2.clauseList[index], 'chargeBeginDate', _this2.baseInfo.beginDate);

        _this2.$set(_this2.clauseList[index], 'chargeEndDate', _this2.baseInfo.endDate);

        if (item1.leaseContractTeamsResourceVos) {
          var resourceIds = item1.leaseContractTeamsResourceVos.map(function (item) {
            if (item.resourceId) {
              return item.resourceId;
            } else {
              return item;
            }
          });
          var includeResourceIds = leaseContractTeamsResourceVos.filter(function (resourceId) {
            return resourceIds.includes(resourceId);
          });

          _this2.$set(_this2.clauseList[index], 'leaseContractTeamsResourceVos', includeResourceIds);
        } else {
          _this2.$set(_this2.clauseList[index], 'leaseContractTeamsResourceVos', leaseContractTeamsResourceVos);
        }
      });
    },
    handlePrev: function handlePrev() {
      if (this.isGeneratingBills) {
        this.$emit('gobackFirst');
      } else {
        this.$emit('handCancle', 'parkingLotContractBack');
      }
    },
    handleGeneratingBills: function handleGeneratingBills() {
      if (this.clauseList.length < 1) {
        this.$message.error('请添加租赁条款');
        return false;
      } else if (this.standardList.length < 1) {
        this.$message.error('请添加收费标准');
        return false;
      }

      for (var i = 0; i < this.clauseList.length; i++) {
        var beginTime = new Date(this.clauseList[i].chargeBeginDate).getTime();
        var endTime = new Date(this.clauseList[i].chargeEndDate).getTime();

        if (this.clauseList[i].leaseContractTeamsResourceVos.length < 1) {
          this.$message.error('请选择车位');
          return false;
        }

        if (!this.clauseList[i].costBearers) {
          this.$message.error('请选择费用承担人');
          return false;
        }

        if (!this.clauseList[i].chargeBeginDate) {
          this.$message.error('请选择收费起始日期');
          return false;
        }

        if (!this.clauseList[i].chargeEndDate) {
          this.$message.error('请选择收费结束日期');
          return false;
        }

        if (beginTime && (beginTime < new Date(this.baseInfo.beginDate).getTime() || beginTime > new Date(this.baseInfo.endDate).getTime())) {
          this.$message.error('收费起始日期应在合同日期范围内');
          return false;
        }

        if (endTime && (endTime < new Date(this.baseInfo.beginDate).getTime() || beginTime > new Date(this.baseInfo.endDate).getTime())) {
          this.$message.error('收费结束日期应在合同日期范围内');
          return false;
        }

        for (var j = 0; j < this.clauseList[i].leaseContractCarVos.length; j++) {
          if (!this.clauseList[i].leaseContractCarVos[j].plateNumber) {
            this.$message.error('请输入车牌号');
            return false;
          }

          if (!this.clauseList[i].leaseContractCarVos[j].plateType) {
            this.$message.error('请选择车牌类型');
            return false;
          }
        }
      }

      for (var _i = 0; _i < this.standardList.length; _i++) {
        if (!this.standardList[_i].chargeStandardId) {
          this.$message.error('请选择收费标准');
          return false;
        }
      }

      if (this.isGeneratingBills) {
        this.$emit('jumpToThird');
      } else {
        this.$emit('handCancle', 'parkingLotContractNext');
      }

      return true;
    },
    handleAddClause: function handleAddClause() {
      var parkLotListOption = this.parkingLotList.map(function (item2) {
        return {
          value: item2.resourceId,
          name: item2.resourceCode
        };
      });
      var leaseContractTeamsResourceVos = this.parkingLotList.map(function (item2) {
        return item2.resourceId;
      });
      var chargeBeginDate = this.baseInfo.beginDate;
      var chargeEndDate = this.baseInfo.endDate;
      this.clauseList.push({
        leaseContractCarVos: [],
        parkLotListOption: parkLotListOption,
        leaseContractTeamsResourceVos: leaseContractTeamsResourceVos,
        chargeBeginDate: chargeBeginDate,
        chargeEndDate: chargeEndDate
      });
    },
    handleAddVehicle: function handleAddVehicle(index) {
      if (!this.clauseList[index].leaseContractCarVos) {
        this.$set(this.clauseList[index], 'leaseContractCarVos', []);
      }

      this.clauseList[index].leaseContractCarVos.push({});
    },
    handleAddStandard: function handleAddStandard() {
      this.standardList.push({});
    },
    // 车牌类型
    loadPlateOption: function loadPlateOption() {
      var _this3 = this;

      fetchListByType('plate_type').then(function (r) {
        _this3.plateOption = r.data.data;
      });
    },
    // 车辆类型
    loadVehicleTypeOption: function loadVehicleTypeOption() {
      var _this4 = this;

      fetchListByType('vehicle_type').then(function (r) {
        _this4.vehicleTypeOption = r.data.data;
      });
    },
    // 车型
    loadModelOption: function loadModelOption() {
      var _this5 = this;

      fetchListByType('car_type').then(function (r) {
        _this5.modelOption = r.data.data;
      });
    },
    handleCheckbox: function handleCheckbox(val, index) {
      if (!val) {
        this.$set(this.bindList[index], 'newStandardId', '');
      }
    },
    handleVehicleDelete: function handleVehicleDelete(index, i) {
      this.clauseList[index].leaseContractCarVos.splice(i, 1);
    },
    handleClauseDelete: function handleClauseDelete(index) {
      this.clauseList.splice(index, 1);
    },
    handleStandardDelete: function handleStandardDelete(index) {
      this.standardList.splice(index, 1);
    },
    handleAdd: function handleAdd() {
      this.list.push({});
    },
    loadRoomOption: function loadRoomOption() {
      var _this6 = this;

      if (this.baseInfo.areaGroupId) {
        fetchRoomList({
          id: this.baseInfo.areaGroupId,
          dataType: '0'
        }).then(function (res) {
          _this6.roomOption = res.data.data;
        });
      }
    },
    loadChargeOption: function loadChargeOption() {
      var _this7 = this;

      fetchChargeList({}).then(function (r) {
        _this7.chargeOption = r.data.data;
      });
    },
    handCancle: function handCancle() {
      this.$emit('handCancle');
    },
    handleBeginDate: function handleBeginDate(time, index) {
      var beginTime = new Date(time).getTime();
      var endTime = new Date(this.clauseList[index].chargeEndDate).getTime(); // 合同日期范围 this.baseInfo.beginDate - this.baseInfo.endDate

      if (time && (beginTime < new Date(this.baseInfo.beginDate).getTime() || beginTime > new Date(this.baseInfo.endDate).getTime())) {
        this.$message({
          message: '收费起始日期应在合同日期范围内',
          type: 'warning'
        });
        this.$set(this.clauseList[index], 'chargeBeginDate', '');
        return;
      }

      if (time && this.clauseList[index].chargeEndDate) {
        if (beginTime > endTime) {
          this.$message({
            message: '收费起始日期不能晚于收费结束日期',
            type: 'warning'
          });
          this.$set(this.clauseList[index], 'chargeBeginDate', '');
        }
      }
    },
    handleEndDate: function handleEndDate(time, index) {
      var beginTime = new Date(this.clauseList[index].chargeBeginDate).getTime();
      var endTime = new Date(time).getTime();

      if (time && (endTime < new Date(this.baseInfo.beginDate).getTime() || endTime > new Date(this.baseInfo.endDate).getTime())) {
        this.$message({
          message: '收费结束日期应在合同日期范围内',
          type: 'warning'
        });
        this.$set(this.clauseList[index], 'chargeEndDate', '');
        return;
      }

      if (time && this.clauseList[index].chargeBeginDate) {
        if (endTime < beginTime) {
          this.$message({
            message: '收费结束日期不能早于收费起始日期',
            type: 'warning'
          });
          this.$set(this.clauseList[index], 'chargeEndDate', '');
        }
      }
    }
  }
};